import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { History } from "@shopify/app-bridge/actions";
import { AppBridgeContext } from "./AppBridgeProvider";
import { appPath } from "../utils/appPaths";

/**
 * After React Router commits a route, align iframe URL + App Bridge history.
 * Avoids pushState before paint (URL ahead of page = blink).
 */
export default function BrowserUrlSync() {
  const location = useLocation();
  const app = useContext(AppBridgeContext);
  const lastBridgePathRef = useRef("");

  useEffect(() => {
    const routerPath = location.pathname || "/";
    const search = location.search || "";
    const bridgePath = `${routerPath}${search}`;

    try {
      const browserPath = appPath(routerPath);
      const expected = `${browserPath}${search}`;
      const current = `${window.location.pathname}${window.location.search}`;
      if (expected !== current) {
        window.history.replaceState(null, "", expected);
      }
    } catch {
      /* iframe history optional */
    }

    if (!app || lastBridgePathRef.current === bridgePath) return;

    try {
      const history = History.create(app);
      history.dispatch(History.Action.REPLACE, bridgePath);
      lastBridgePathRef.current = bridgePath;
    } catch {
      /* noop */
    }
  }, [app, location.pathname, location.search]);

  return null;
}
